import { render } from "./Help.vue?vue&type=template&id=b87a410e&scoped=true&bindings={\"msg\":\"props\"}"
import script from "./Help.vue?vue&type=script&lang=js"
export * from "./Help.vue?vue&type=script&lang=js"

import "./Help.vue?vue&type=style&index=0&id=b87a410e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-b87a410e"

export default script